import { render, staticRenderFns } from "./forget-password-popup-component.vue?vue&type=template&id=9308e7dc"
import script from "./forget-password-popup-component.ts?vue&type=script&lang=ts&external"
export * from "./forget-password-popup-component.ts?vue&type=script&lang=ts&external"
import style0 from "./forget-password-popup-component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports